export const StyledLink = ({heading, color = 'blue', path}:{heading: string, color?: string, path: string})=>{

    return(
        <a href={path}>
            <div className='flex-row' style={{justifyContent:'flex-start', alignItems:'center', width:'100%' }} >
                <div style={{width: 10, height: 20, backgroundColor: color}} />
                <div style={{width: 5}} ></div>
                <h4 style={{color:'blue'}} >{heading}</h4>
            </div>
        </a>
    )
}